<template>
  
  <div class="full-height d-flex justify-content-center align-items-center topBk">
 <div class="container d-flex justify-content-center align-items-center">
 <div class="d-flex flex-column justify-content-between align-items-center bg-white p-2 borderRadius" style="width:max-content">

   <div>
    <span class="title">微信扫码登录</span>
   </div>
    
    <div v-if="qrUrl!=null" class="mt-1">
      <img :src="qrUrl" class="qr">
    </div>
    <div v-else style="position: relative;" class="mt-1">
      <div v-if="isLoading" class="qr d-flex justify-content-center">
        <grid-loader :loading="isLoading" :color="spinnerColor"></grid-loader>
      </div>
    </div>

    <div class="alertText d-flex align-items-center mt-1">
        用微信<img src="../assets/wechatIcon.png" style="width: 0.225rem;height:0.225rem">扫码关注公众号登录
    </div>

    <div class="d-flex justify-content-between align-items-center mt-2">
      <div>
        <div class="btn normalBtn" v-if="!isLoading" @click="getQR()">
        <span >刷新二维码</span>

      </div>
      <div v-else class="btn btnDiabled">
        刷新二维码
      </div>

      </div>
      

      <div @click="back" class="btn ml-1">返回</div>
    </div>
   
    <p v-show="error" class="error-message">{{ error }}</p>

</div>
</div>
</div>
</template>

<script>

import axios from 'axios';

// import QrcodeVue from 'qrcode.vue'

import GridLoader from 'vue-spinner/src/GridLoader.vue'

export default {
  data(){
    return {
      isLoading:false,
      qrUrl:null,
      ticket:null,
      interval:null,
      qr_timeout:null,
      qrReady:false,
      spinnerSize:"1.625rem",
      spinnerColor:"#262626",
      expiredSeconds:100000,
      error:''
    }
  },
  components: {
    GridLoader
  },

  setup(){

    var token=localStorage.getItem('sessionToken')
     axios.defaults.headers.common['X-Parse-Session-Token'] = token
     var ticket=localStorage.getItem('ticket')
     if(ticket!=null)
     {
      this.ticket=ticket
     }
    
   
  },
  unmounted(){


      if(this.interval!=undefined && this.interval!=null)
      {
        clearInterval(this.interval)
      }
  },
  


  mounted(){
  
    if(this.interval!=null)
    {
      clearInterval(this.interval)
    }
    var token=localStorage.getItem('sessionToken');
     if(token!=undefined && token!=null &&token!='')
     {
      this.$router.push('index')
      return
     }

     this.getQR()

  },


  methods:{
    back(){
        this.$router.go(-1)
      },

    async getQR(){
      this.isLoading=true;
      this.qrUrl=undefined;
      if(this.interval!=undefined && this.interval!=null)
      {
        clearInterval(this.interval)
        
      }

      
      try{
         
          var code=localStorage.getItem('user_code')
          if (code==undefined)
          {
            code='admin'
          }
          console.log(code)
          const response = await axios.get(this.domain+'xhs/get_login_qr?code='+code);
          var data=response.data
        
          if(data['status']=='Suc')
          {
            this.error=''
            this.qrUrl=data['qr']
            this.expiredSeconds=data['expired']*1000
            this.ticket=data['ticket']
            this.qrReady=true;  
            
            this.interval=setInterval(() => {
                if(this.qrReady)
                {
                  this.checkLogin()
                }
                
                
              }, 1000);
          }
          else
          {
            this.error=data['msg']
          }
      }
      catch(error){
        this.error=error.msg

      }
        finally
        {
          this.isLoading=false;
        }
    },
    async checkLogin(){

      if(this.ticket==null)
      {
        return
      }
      const response = await axios.get(this.domain+'xhs/check_login_qr?ticket='+this.ticket);
      var data=response.data
    
      if(data['status']=='Suc')
      {
        if(data['registered'])
        {

          if(this.interval!=undefined && this.interval!=null)
          {
            clearInterval(this.interval)
          }
          if(this.qr_timeout!=undefined && this.qr_timeout!=null)
          {
            clearTimeout(this.qr_timeout)
          }
          if(data['session']!=undefined)
          {
            localStorage.setItem('sessionToken', response.data['session']);
            localStorage.setItem('role', response.data['role']);
          }
          // this.$emit('login_suc', true);
          this.$router.push('/index/user')
        }
      }
    }


  },

   
  
};
</script>
<style scoped>

.error-message{
  color:red;
  word-break: break-all;
}

</style>
